module.exports = __webpack_public_path__ + "static/img/14001032.563d1fb0.png";